// extracted by mini-css-extract-plugin
module.exports = {"callus":"Callus_callus__37BNt"};